import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Logo from "../../assets/images/Group.png";
import BodyPic from "../../assets/images/Pic.png";
import OTB_Illustration from "../../assets/svg/OBJECTS.svg";
import "../../pages/Login/Login.css";

const Otp = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const location = useLocation();
  const devOtp = location.state?.otp;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const API_BASE_URL = "https://estbn.com/EstbnNew/public/api";

  // Handle typing and auto-focus next
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Focus next input
    if (element.nextSibling && element.value !== "") {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && e.target.previousSibling) {
      e.target.previousSibling.focus();
    }
  };

  const handleVerify = async () => {
    const otpCode = otp.join("");

    if (otpCode.length < 6) {
      setError("يرجى إدخال رمز التفعيل كاملاً");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const formData = new FormData();

      const name = localStorage.getItem("userName");
      formData.append("login", name);
      formData.append("otp", otpCode);

      const tempToken = localStorage.getItem("token");

      const response = await axios.post(
        `${API_BASE_URL}/portal/stuff/verify-otp`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${tempToken}`,
          },
        }
      );
      if (response.data.success === true) {
        localStorage.setItem("token", response.data.data.data.token);
        localStorage.setItem(
          "userInfo",
          JSON.stringify(response.data.data.data),
        );
        console.log(response.data);
        const roles = response.data.data.data.stuff.roles.map((r) => r.name);
        if (
          roles.some((r) => ["engineer", "technician", "driver"].includes(r))
        ) {
          navigate("/Home");
        } else {
          navigate("/dashboard");
        }
      }
    } catch (err) {
      console.log(err);
      const message =
        err.response?.data?.message || "فشل التحقق، يرجى المحاولة مرة أخرى";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleAutoFill = (code) => {
    const otpString = String(code);

    if (otpString.length === 6) {
      const newOtp = otpString.split("");
      setOtp(newOtp);
    }
  };

  return (
    <>
      <div className="w-25 mx-auto my-2">
  {devOtp && (
        <div className="alert alert-info d-flex justify-content-between align-items-center">
          <span>
            Dev OTP: <strong>{devOtp}</strong>
          </span>
          <button
            className="btn btn-sm btn-dark"
            onClick={() => handleAutoFill(devOtp)}
          >
            Copy & Fill
          </button>
        </div>
      )}
      </div>
    
      <div className="row">
        <div className="col-md-7 col-xs-12 col-sm-12 col-lg-5 sideForImg">
          <div className="header bg-black rounded-3 border-end border-3 border-black">
            <div className="logoHeader">
              <img className="loginLogo" src={Logo} alt="Logo" />
              <p className="mainText">
                Login to manage orders and improve efficiency
              </p>
            </div>
            <img className="mainImg" src={BodyPic} alt="Car Images" />
          </div>
        </div>

        <div className="col-md-5 col-sm-12 col-xs-12 col-lg-7 p-0 ps-2 pe-4 sideForinfo otp-right-side">
          <div className="back-btn-container w-100 d-flex justify-content-end p-4">
            <Link to="/login" className="text-dark">
              <i className="bi bi-chevron-right fs-4"></i>
            </Link>
          </div>

          <div className="otp-content text-center">
            <img
              src={OTB_Illustration}
              alt="OTP Illustration"
              className="otp-illustration mb-4"
            />

            <h2 className="otp-title">ادخال رمز التفعيل</h2>
            {/* FIX: Changed display text to show username */}
            <p className="otp-subtitle">
              أدخل الكود المرسل إلى{" "}
              {localStorage.getItem("userName") || "المستخدم"}
            </p>

            <div
              className="otp-input-group d-flex justify-content-center gap-2 my-4"
              dir="ltr"
            >
              {otp.map((data, index) => (
                <input
                  className="otp-field"
                  type="text"
                  name="otp"
                  maxLength="1"
                  key={index}
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onFocus={(e) => e.target.select()}
                />
              ))}
            </div>

            {error && <p className="text-danger small mb-3">{error}</p>}

            <div className="w-75 mx-auto">
              <button
                className="btn btn-secondary w-100 py-2 confirm-btn"
                onClick={handleVerify}
                disabled={loading}
              >
                {loading ? "جاري التحقق..." : "تأكيد"}
              </button>
            </div>

            <div className="resend-container mt-4">
              <p className="resend-text">
                لم يتم ارسال الكود ؟{" "}
                <Link to="#" className="resend-link">
                  اعادة الارسال
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
